import React from 'react'
import { styled } from 'linaria/react'
import ArticleViewCard from './ArticleViewCard'
import ArticlesHeaderAlt from './ArticlesHeaderAlt'
import ListCardSkeleton from '../../../Core/Skeletons/ListCardSkeleton'

const ArticlesContainer = styled.div``

const ArticlesGridViewer = ({ articlesData, loading }) => {
   return (
      <>
         <ArticlesHeaderAlt title={articlesData?.name} />
         <ArticlesContainer className="row">
            {articlesData?.articles?.map((article, i) => {
               return (
                  <div
                     key={i}
                     className="d-flex col-12 col-sm-6 col-lg-3 mb-32"
                     // className="col-6 col-sm-6 col-xl-4 col-xxl-3 col-xxxl-2 d-flex mb-32"
                  >
                     <ArticleViewCard article={article}></ArticleViewCard>
                  </div>
               )
            })}
         </ArticlesContainer>
      </>
   )
}

export default ArticlesGridViewer
